<div class="wrapper">
    <h1 class="pageTitle">Thanks {{client?.first_name}} {{client?.last_name}}! Your booking has been confirmed</h1>
    <app-notifications [notification]="'confirmation_page_notification_banner_child'"></app-notifications>
</div>
<div class="text-center">
    <hr>
    <h4> Your reference number is <strong>{{bookings?.id}}</strong></h4>
    <hr>
</div>

<div class="mb-2 text-center">
    <button class="btn btn-primary govuk-button button-sizer" type="button" title="Make another booking"
        style="margin-left: 15px; margin-right: 15px;" aria-label="Make another booking"
        (click)="restartJourney()"><span>
            Make another booking
        </span></button>
</div>

<div class="container" id="container">
    <div class="page__main-content">
        <div class="bb-panel" *ngIf="selectedService">
            <div class="row panel-row-heading">
                <span class="section-heading col-sm-12">
                    <strong>
                        Your full booking details will be sent in an email confirmation soon.
                    </strong>
                    <br>
                    <br>
                    <p>
                        Please check your junk/ spam folder if you do not receive the email.
                    </p>
                    <p>
                        Please arrive within your booking slot, otherwise you may not be permitted access to the
                        Recycling Centre.
                    </p>
                </span>
            </div>
            <div class="row panel-row">
                <div class="col-sm-4">{{'CONFIRMATION.DATE_AND_TIME' | translate}}</div>
                <div class="col-sm-8">
                    <p>{{selectedSlot?.datetime | date: 'EEEE d MMMM yyyy'}}</p>
                    <p>{{selectedSlot?.datetime | date: 'HH:mm'}} - {{endSlot | date: 'HH:mm'}}</p>
                </div>
            </div>
            <div class="row panel-row">
                <div class="col-sm-4">{{'CONFIRMATION.LOCATION' | translate}}</div>
                <div class="col-sm-8">
                    <span>{{address?.address1}}, </span>
                    <span *ngIf="address?.address2">{{address?.address2}}, </span>
                    <span *ngIf="address?.address3">{{address?.address3}}, </span>
                    <span *ngIf="address?.address4">{{address?.address4}}, </span>
                    <span *ngIf="address?.address5">{{address?.address5}}, </span>
                    {{address?.postcode}}
                </div>
            </div>

            <div class="row panel-row">
                <div class="col-sm-4">Personal info</div>
                <div class="col-sm-8">{{client.first_name}} {{client.last_name}} <br>
                    {{client?.email_address}} {{client?.email}}<br>
                    {{client.mobile_number}}
                </div>
            </div>
        </div>

        <div class="bb-panel" *ngIf="showMap">
            <app-leaflet-map [num]="2"></app-leaflet-map>
        </div>

        <div class="bb-panel" *ngIf="selectedService && total > 1">
            <div class="row panel-row-heading">
                <h2 class="section-heading col-sm-12">Your purchases</h2>
            </div>
            <div class="row panel-row">
                <div class="col-sm-8">item</div>
                <div class="col-sm-4">Price</div>
            </div>
            <div class="row panel-row">
                <div class="col-sm-8">{{selectedService.name}}</div>
                <div class="col-sm-4">{{selectedService.price / 100 | currency:'GBP':true}}</div>
            </div>

            <div *ngFor="let item of bookingSummaryData">
                <div class="row panel-row" *ngIf="item.detail_type === 'check-price'">
                    <div class="col-sm-8">{{item.name}}</div>
                    <div class="col-sm-4">{{item.price / 100 | currency:'GBP':true}}</div>
                </div>
            </div>

            <div class="row panel-row">
                <div class="col-sm-8"><strong>Total</strong></div>
                <div class="col-sm-4">{{total / 100 |
                    currency:'GBP':true}} </div>
            </div>
        </div>

    </div>

    <div class="page__main-content">
        <div class="button-navigation">
            <div class="row mt-4">
                <div class="col-12">
                    <button type="button" class="btn btn-primary govuk-button button-sizer float-left" (click)="print()"
                        title="Print" aria-label="Print"><span>
                            <fa-icon [icon]="faPrint"></fa-icon><span>Print</span>
                        </span></button>

                    <button class="btn btn-primary govuk-button button-sizer float-right" type="button"
                                (click)="goHome()"
                                title="Return home" aria-label="Return home" ><span>
                                Return home
                            <fa-icon [icon]="faChevronRight"></fa-icon>
                        </span></button>
                </div>
            </div>
            <br>
        </div>
    </div>